import styled from "styled-components";
import { generic as sg } from "../../../../../ui/_themes/constants";

export const Overlay = styled.div`
  position: fixed;
  pointer-events: auto;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: ${sg.layers.activity - 1};
`;
